import { render, staticRenderFns } from "./DemoCenterLinkBar.vue?vue&type=template&id=2e0bb076"
import script from "./DemoCenterLinkBar.vue?vue&type=script&lang=js"
export * from "./DemoCenterLinkBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports